import { createHosting, listHostings, getHosting, updateHosting, deleteHosting } from '../lib/db/hostings'

export interface ApiResponse<T = any> {
  success: boolean
  data?: T
  error?: string
  message?: string
}

export class HostingsAPI {
  static async create(data: any): Promise<ApiResponse> {
    const result = await createHosting(data)
    return { success: true, data: result.data }
  }
  static async list(): Promise<ApiResponse> {
    const result = await listHostings()
    return { success: true, data: result.data }
  }
  static async get(id: string): Promise<ApiResponse> {
    const result = await getHosting(id)
    return { success: true, data: result.data }
  }
  static async update(id: string, data: any): Promise<ApiResponse> {
    const result = await updateHosting(id, data)
    return { success: true, data: result.data }
  }
  static async delete(id: string): Promise<ApiResponse> {
    const result = await deleteHosting(id)
    return { success: true, data: result.data }
  }
}